<template>
    <RowColumn type="none" class="bg-white rounded-shadow m-1">
        <div class="grid grid-cols-12 gap-10 py-5 sm:px-5">
            <div class="col-span-12  md:col-span-4 relative">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('product.name') }}
                </div>
                <b-form-input class="border-gray-300 h-11 focus:ring-0"/>
            </div>

            <div class="col-span-12 gap-4 md:col-span-4 relative">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('category') }}
                </div>
                <b-form-select
                    class="border-gray-300 h-11 focus:ring-0"
                    text-field="shortName"
                    :options="categories"
                    value-field="id"
                >
                </b-form-select>
            </div>

            <div class="col-span-12 gap-4 md:col-span-4 relative">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('unitOfMeasure.unitOfMeasure') }}
                </div>
                <v-select
                    class="d-block"
                    :multiple="true"
                    label="shortName"
                    :clearable="false"
                    v-model="selectOptions"
                    :options="categories"
                    :reduce="option => option.id"
                >
                </v-select>
            </div>
            <div class="col-span-12 gap-4 md:col-span-4 relative">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('service.price') }}
                </div>
                <b-form-input class="border-gray-300 h-11 focus:ring-0"/>
            </div>
            <div class="col-span-12 gap-4 md:col-span-4 relative">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                    {{ $t('production.properties.bestBefore') }}
                </div>
                <b-form-input type="date" class="border-gray-300 h-11 focus:ring-0"/>
            </div>
            <div class="col-span-12 rounded md:col-span-4 relative">
                <label
                    for="image"
                    class="rounded w-full h-28 flex flex-col justify-center items-center border border-gray-300 cursor-pointer"
                >
                    <img src="/images/imageIcon.png" alt="" class="h-11 mb-2">
                    <span class="text-gray-700">{{ $t('production.selectFile') }}</span>
                    <span class="text-gray-500 text-sm">png, jpg, jpeg</span>
                    <input
                        id="image"
                        style="display: none"
                        type="file"
                        accept="image/*"
                    >
                </label>
            </div>
        </div>
        <div class="container pt-3">
            <div class="col-span-8">
                <CurrencyCollapse :is-bg-white="false" class="mt-4 pb-2">
                    <h5 class="font-bold">
                        {{ $t('production.lossAddition') }}
                    </h5>
                    <div class="border p-4">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                            <div v-for="(input, index) in inputs" :key="index"
                                 class="flex items-center justify-between">
                                <div class="text-gray-500 font-bold text-sm">
                                    {{ input.label }}
                                </div>
                                <div class="relative w-40 ml-2">
                                    <b-form-input type="number" class="border-gray-300 h-11 focus:ring-0 w-full"/>
                                    <div
                                        class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 left-2"
                                    >
                                        {{ "(%)" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4 flex justify-end">
                            <b-button class="h-11 w-40" variant="primary" id="barcode" @click="showModal">
                                {{ $t("add") }}
                                <font-awesome-icon :icon="['fas', 'plus']"/>
                            </b-button>
                        </div>
                    </div>
                    <!-- Modal -->
                    <b-modal
                        hide-footer
                        id="add-input-modal"
                        v-model="isModalVisible"
                        :title="$t('production.properties.addLossTitle')"
                    >
                        <b-form @submit.stop.prevent="addInput">
                            <b-form-group :label="$t('production.properties.lossName')" label-for="new-input-label">
                                <b-form-input
                                    required
                                    id="new-input-label"
                                    v-model="newInputLabel"
                                    :placeholder="$t('production.properties.enterLossName')"
                                />
                            </b-form-group>
                            <div class="d-flex gap-4 justify-content-end">
                                <b-button type="submit" variant="primary">{{ $t("add") }}</b-button>
                                <b-button variant="secondary" @click="isModalVisible = false">
                                    {{ $t("cancel") }}
                                </b-button>
                            </div>
                        </b-form>
                    </b-modal>
                </CurrencyCollapse>
            </div>
            <div class="flex justify-start pt-2">
                <ButtonTag
                    :is-tw-main-btn="true"
                    :is-w100="false"
                >
                    <router-link
                        class="pt-1 text-white  text-decoration-none"
                        :to="$i18nHelper.getUrl('production/properties/add')"
                    >
                        {{ $t('save') }}
                    </router-link>
                </ButtonTag>
            </div>
        </div>
    </RowColumn>
</template>

<script>
import RowColumn from "@/components/RowColumn.vue";
import {mapActions} from "vuex";
import ButtonTag from "@/components/html/ButtonTag.vue";
import vSelect from 'vue-select'
import CurrencyCollapse from "@/components/CurrencyCollapse.vue";

export default {
    name: "Add",
    components: {CurrencyCollapse, ButtonTag, RowColumn, vSelect},
    data() {
        return {
            selectOptions: [],
            newInputLabel: "",
            isModalVisible: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'production.properties.title', url: 'production/properties'},
                {name: 'add'},
            ],
            inputs: [
                {label: "Tozalashda yo'qotish"},
                {label: "Saqlashdagi yo'qotish"},
                {label: "Pishirishda yo'qotish"},
                {label: "Ishlov berishda yo'qotish"},
            ],
            categories: [
                {id: 1, shortName: "dona"},
                {id: 2, shortName: "kg"},
            ],
        }
    },
    methods: {
        ...mapActions(['setBreadcrumbItems']),
        showModal() {
            this.isModalVisible = true;
        },
        addInput() {
            if (this.newInputLabel) {
                this.inputs.push({label: this.newInputLabel});
                this.newInputLabel = "";
                this.isModalVisible = false;
            }
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    }
}
</script>

<style scoped>

</style>
